import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

import { GoogleLocationService, GoogleParsedLocation } from '../../../core/services/google-location.service';
import { AutocompleteOption } from '../autocomplete-select/autocomplete-select.component';

@Component({
  selector: 'app-address-autocomplete',
  standalone: false,
  templateUrl: './address-autocomplete.html',
  styleUrl: './address-autocomplete.scss',
})
export class AddressAutocomplete implements OnInit {
  @Input() countryCode = '';
  @Input() regionName = '';
  @Input() selectClass = 'form-select';
  @Output() locationSelected = new EventEmitter<GoogleParsedLocation>();

  readonly control = new FormControl('', { nonNullable: true });
  readonly search = (query: string) => this.searchLocations(query);
  options: AutocompleteOption[] = [];
  error = '';

  constructor(readonly locations: GoogleLocationService) {}

  ngOnInit(): void {
    this.control.valueChanges.subscribe((placeId) => {
      if (placeId) void this.selectLocation(placeId);
    });
  }

  private async searchLocations(query: string): Promise<AutocompleteOption[]> {
    this.error = '';
    this.options = (await this.locations.searchSuggestions(query, this.countryCode)).map((item) => ({
      value: item.placeId,
      label: item.description,
    }));
    return this.options;
  }

  private async selectLocation(placeId: string): Promise<void> {
    const location = await this.locations.getPlaceDetails(placeId);
    if (!location) return;
    const selectedCountry = this.countryCode.trim().toUpperCase();
    if (selectedCountry && location.countryCode.toUpperCase() !== selectedCountry) {
      this.error = 'Choose an address inside the selected country.';
      this.control.setValue('', { emitEvent: false });
      return;
    }
    const selectedRegion = this.regionName.trim().toLowerCase();
    if (selectedRegion && location.region.trim().toLowerCase() !== selectedRegion) {
      this.error = 'Choose an address inside the selected state or region.';
      this.control.setValue('', { emitEvent: false });
      return;
    }
    this.error = '';
    this.locationSelected.emit(location);
  }
}
